import { atomWithStorage } from 'jotai/utils';
import { makeJotaiSessionStorage } from './createSessionStorage';
import { SyncStorage } from 'jotai/vanilla/utils/atomWithStorage';

const initialUserInfor: CompanyInfor = {
  companyidx: 0,
  companyname: '',
  countrycode: '',
  countrystringkey: '',
  categoryidx: 0,
  category: '',
  centeridx: 0,
  subscribeyn: false,
  salestypeidx: 0
};

const localStorageKey = 'companyInformation';

const companyInforAtom = atomWithStorage(
  localStorageKey,
  initialUserInfor,
  makeJotaiSessionStorage() as SyncStorage<CompanyInfor>
);

export default companyInforAtom;
